// @flow
import React, { Component } from 'react';
import { FormattedMessage, type IntlShape } from 'react-intl';

import type {
  FieldDefinition,
  MetadataDefinition,
  MetadataMapping,
} from 'state/types';
import { ADD_EXTRACT_MAPPING_PANEL_ID } from 'util/constants';
import {
  displayNameForField,
  getExtractMetadataForField,
  getFieldsThatEmbedToMetadata,
  getMetadataDef,
  MD_MAPPING_TYPE_EXTRACT,
} from 'util/fieldsPageUtils';
import localizedStrings from 'util/localizedStrings';
import DialogPanel from 'view/App/DialogPanels/DialogPanel';
import { actions as dialogPanelActions } from 'portfolio-shared/state/reducers/dialogPanelReducer';

const { hideDialogPanel } = dialogPanelActions;

type EMMRProps = {
  disabled: boolean,
  fdId: string,
  md: MetadataDefinition,
  removeMapping: Function,
};

export class ExtractMetadataMappingRow extends Component<EMMRProps> {
  handleRemoveExtractMapping: Function;

  constructor() {
    super();
    this.handleRemoveExtractMapping = this.handleRemoveExtractMapping.bind(
      this
    );
  }

  handleRemoveExtractMapping() {
    const { fdId, md, removeMapping } = this.props;
    removeMapping(fdId, md.id, MD_MAPPING_TYPE_EXTRACT);
  }

  render() {
    const { disabled, md } = this.props;
    return (
      <div
        className={`fields-mapping-row ${
          disabled ? ' fields-mapping-row-disabled' : ''
        }`}
        data-test-name="extract-mapping-row"
      >
        {md.displayName}
        <button
          className="button is-dark is-inverted"
          data-test-name="remove-extract-mapping"
          disabled={disabled}
          onClick={this.handleRemoveExtractMapping}
          type="button"
        >
          <i className="fa fa-minus-circle" />
        </button>
      </div>
    );
  }
}

type AEProps = {
  activePanelId?: string,
  addExtract: Function,
  field: FieldDefinition,
  formatMessage: Function,
  hideDialogPanel: typeof hideDialogPanel,
  mappings: MetadataMapping[],
  mds: MetadataDefinition[],
};

export class AddExtractMapping extends Component<AEProps> {
  handleAddExtract: Function;
  extractSelect: any;

  constructor() {
    super();
    this.handleAddExtract = this.handleAddExtract.bind(this);
  }

  handleAddExtract() {
    const { mds } = this.props;
    const md = getMetadataDef(this.extractSelect.value, mds);
    md && this.props.addExtract(md.id);
  }

  render() {
    const {
      activePanelId,
      field,
      hideDialogPanel,
      formatMessage,
      mappings,
      mds,
    } = this.props;
    const existingExtractMetadata = getExtractMetadataForField(
      field.id,
      mappings,
      mds
    );
    const freeMetadataDefs = mds.filter(
      md => !existingExtractMetadata.includes(md)
    );
    return (
      activePanelId === ADD_EXTRACT_MAPPING_PANEL_ID && (
        <DialogPanel
          activePanelId={activePanelId}
          contentStyle={{ width: 500, height: 250 }}
          customButtonText={formatMessage(localizedStrings.ADD)}
          hideDialogPanel={hideDialogPanel}
          onSave={this.handleAddExtract}
          panelId={ADD_EXTRACT_MAPPING_PANEL_ID}
          panelTitle={formatMessage(
            localizedStrings.FIELD_ADD_EXTRACT_METADATA
          )}
        >
          <div
            style={{ display: 'flex', alignItems: 'center', margin: '20px' }}
            data-test-name="add-mapping-dialog"
          >
            <div className="select">
              <select
                data-test-name="add-mapping-select"
                ref={s => {
                  this.extractSelect = s;
                }}
              >
                {freeMetadataDefs.map(md => (
                  <option
                    key={md.id}
                    value={md.id}
                    data-test-name="extract-field"
                  >
                    {md.displayName}
                  </option>
                ))}
              </select>
            </div>
          </div>
        </DialogPanel>
      )
    );
  }
}

type MWProps = {
  field: FieldDefinition,
  fieldDefinitions: FieldDefinition[],
  intl: IntlShape,
  metadataDef: MetadataDefinition,
  metadataMappings: MetadataMapping[],
};

export class MappingWarnings extends Component<MWProps> {
  render() {
    const {
      fieldDefinitions,
      intl,
      metadataDef,
      metadataMappings,
    } = this.props;
    const fieldDefs =
      getFieldsThatEmbedToMetadata(
        metadataDef.id,
        metadataMappings,
        fieldDefinitions
      ) || [];
    const labels = fieldDefs
      .map(fd => displayNameForField(intl, fd.systemName))
      .sort((a, b) => {
        return a.toLowerCase().localeCompare(b.toLowerCase());
      });
    if (fieldDefs.length > 1) {
      return (
        <div className="message is-danger" style={{ marginTop: '8px' }}>
          <div className="message-body" data-test-name="multiple-embed-warning">
            <FormattedMessage
              {...localizedStrings.FIELD_MULTIPLE_EMBED_WARNING}
            />
            <br />
            {metadataDef.displayName}:
            <ul>
              {labels.map(label => (
                <li className="is-indented" key={label}>
                  • {label}
                </li>
              ))}
            </ul>
          </div>
        </div>
      );
    } else {
      return null;
    }
  }
}



// WEBPACK FOOTER //
// ./src/view/Pages/CatalogsPage/FieldFormMappings.js